export default __webpack_public_path__ + "static/media/finger_print.42a0c0e5.png";